import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';

const FAQS = [
  {
    q: 'How do I submit a safety report?',
    a: 'Open the SafeHer app, tap the map, and tap the report button. Add a description, choose a severity level, and drop a pin on the location. Your identity is never attached to the report.',
  },
  {
    q: 'Are reports really anonymous?',
    a: 'Yes. Reports are tagged with a session-derived pseudonymous ID, not your name or email. Other users, moderators, and admins never see who submitted a report.',
  },
  {
    q: 'How do I verify my email address?',
    a: 'After registering, check your inbox for an email from SafeHer. Click the verification link. If you did not receive it, open the app, go to Profile, and tap Resend verification email.',
  },
  {
    q: 'How do I become a moderator?',
    a: 'Open the app, go to Profile, and tap the Moderator button. Fill in your city and reason for applying. Moderator applications are reviewed by the SafeHer team.',
  },
  {
    q: 'How do I reset my password?',
    a: 'On the login screen, tap Forgot Password. Enter your email address and we will send you a reset link valid for one hour.',
  },
  {
    q: 'How do I delete my account?',
    a: 'In the app, go to Profile and tap Delete. On the website, go to your Profile tab and tap Delete Account. You will be asked to confirm by typing DELETE. See the full deletion policy below.',
  },
  {
    q: 'Why is SafeHer not an emergency service?',
    a: 'SafeHer is a community awareness and prevention tool. If you are in immediate danger, contact your local emergency services. SafeHer reports are reviewed by community moderators, not emergency responders.',
  },
  {
    q: 'Is my location stored?',
    a: 'No. Location is used only in-session to center the map and surface nearby reports. We do not store your device location history.',
  },
];

export default function Support() {
  const [open, setOpen] = useState(null);
  const [query, setQuery] = useState('');

  const filtered = FAQS.filter(
    f =>
      query.trim() === '' ||
      f.q.toLowerCase().includes(query.toLowerCase()) ||
      f.a.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="privacy-page">
      <header className="privacy-header">
        <Link to="/" className="back-button">← SafeHer</Link>
        <h1>Support</h1>
        <p>How can we help?</p>
      </header>

      <div className="privacy-content">

        {/* Search */}
        <input
          type="text"
          placeholder="Search help articles..."
          value={query}
          onChange={e => setQuery(e.target.value)}
          style={{
            width: '100%',
            padding: '12px 16px',
            fontSize: '15px',
            border: '1.5px solid #ddd',
            borderRadius: '8px',
            outline: 'none',
            marginBottom: '2rem',
            boxSizing: 'border-box',
          }}
        />

        {/* FAQ */}
        <h2>Common questions</h2>
        {filtered.length === 0 && (
          <p style={{ color: '#888' }}>No results for "{query}". Try a different search or email us below.</p>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '2rem' }}>
          {filtered.map((faq, i) => (
            <div
              key={i}
              style={{
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                overflow: 'hidden',
              }}
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  padding: '14px 16px',
                  background: open === i ? '#f0faf8' : '#fff',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '15px',
                  fontWeight: 500,
                  color: '#111',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                {faq.q}
                <span style={{ color: '#00897B', fontSize: '18px', flexShrink: 0, marginLeft: '12px' }}>
                  {open === i ? '−' : '+'}
                </span>
              </button>
              {open === i && (
                <div style={{ padding: '0 16px 14px', fontSize: '14px', color: '#444', lineHeight: '1.6' }}>
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Account deletion */}
        <h2>Account and data deletion</h2>
        <p>
          You can delete your account at any time from the app or the website. Personal data is removed
          immediately. Community data (reports, comments, upvotes) is anonymised by default, or deleted
          within 90 days if you request it at the time of deletion.
        </p>
        <p>
          <Link to="/delete-account" style={{ color: '#00897B', fontWeight: 500 }}>
            Full deletion instructions and policy
          </Link>
        </p>

        {/* Contact */}
        <h2>Contact us</h2>
        <p>
          If you could not find the answer above, email us at{' '}
          <a href="mailto:support@safeher.xyz" style={{ color: '#00897B', fontWeight: 500 }}>
            support@safeher.xyz
          </a>
          . We respond within 48 hours.
        </p>

        <div className="privacy-last-updated">
          SafeHer · <a href="https://safeher.xyz">safeher.xyz</a>
        </div>
      </div>
    </div>
  );
}
